import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What are the prizes?</div>
        <p>
          The Winner(s) of the T-Shirt Giveaway (the “Winner”) will receive
          T-Shirt. The prize(s) shall be determined solely by the Sponsor. There
          shall be no cash or other prize substitution permitted except at the
          Sponsor’s discretion. The prize is non-transferable.The prize is
          non-transferable. The Winner, upon acceptance of the prize, is solely
          responsible for all expenses related to the prize,including without
          limitation any and all local, state, and federal taxes. The Winner
          shall not transfer assignment of the prize to others nor shall the
          Winner request the cash equivalent or prize substitution. By accepting
          the prize, the selected Winner grants permission for the Sponsor to
          use the Winner’s likeness, entry, and name for purposes of advertising
          and trade without further compensation unless prohibited by law.
        </p>
      </div>
    </div>
  );
};

export default Q2;
